@if (numberOfThemes() > 2) {
  <jmkw-popout-button
    [iconName]="iconName"
    [contentComponent]="componentRef"
    [tooltipText]="tooltipText"
    [automationKey]="popoutAutomationKey"
  ></jmkw-popout-button>
}
@if (numberOfThemes() > 1 && numberOfThemes() < 3) {
  <jmkw-button
    [iconName]="iconName"
    [active]="isDark"
    (onClick)="toggleTheme()"
    [automationKey]="toggleAutomationKey"
    >
  </jmkw-button>
}
